module.exports = __webpack_public_path__ + "yadokari_creative_2.png?fbea07d677234cae396d266d02986af3";


//////////////////
// WEBPACK FOOTER
// ./static/img/yadokari_creative_2.png
// module id = 210
// module chunks = 0